import { getData, getTimestampData } from '@/components/report/service';
import ActualDetail from '@/Entity/ActualDetail';
import Queryable from '@/Entity/Tools/Queryable';
import { Result } from '@/Entity/Tools/Result';
import GenerateCondit, { Bound, IGnerCondit } from '@/models/GenerateCondit';
import { Aggregator, CountAllArea, CountTicket } from '@/models/GenerateCondit/Interrelated';
import { crudRequest } from '@/services/api';
import { isArray } from 'lodash';
import moment from 'moment';

const endDateFormat = 'YYYY-MM-DD 00:00:00';
const params = {
  productType: [],
  direction: '',
  startDate: moment().subtract(1, 'days').format(endDateFormat),
  endDate: moment().format('YYYY-MM-DD 23:59:59'),
};
const dealDate = (start, end) => {
  let dateList = [];
  var startTime = new Date(start);
  var endTime = new Date(end);

  while (endTime.getTime() - startTime.getTime() >= 0) {
    var year = startTime.getFullYear();
    var month =
      startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
    var day =
      startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate();
    dateList.push(year + '-' + month + '-' + day);
    startTime.setDate(startTime.getDate() + 1);
  }
  return dateList;
};
const actualTable = 'static_actual_time_consume_result'; // 实际表
const preTable = 'static_actual_time_consume_result_sat';

export default {
  namespace: 'staticcashrate',
  state: {
    activeKey: 'organization',
    //
    // searchParams: { ...params },
    orgSearch: { ...params },
    counSearch: { ...params },

    organizationTable: [],
    countryTable: [],
    orgPage: 1,
    orgPageSize: 20,
    counPage: 1,
    counPageSize: 20,
    dataSql: '',

    countryProductDataList: [],
    countryTimestamps: dealDate(
      moment(params.startDate).format('YYYY-MM-DD'),
      moment(params.endDate).format('YYYY-MM-DD'),
    ),
    organizationProductDataList: [],
    organizationTimestamps: dealDate(
      moment(params.startDate).format('YYYY-MM-DD'),
      moment(params.endDate).format('YYYY-MM-DD'),
    ),
    productDataSql: '',
  },

  effects: {
    *getData(_, { put, call, select }) {
      const { orgSearch, counSearch, activeKey } = yield select(
        ({ staticcashrate }) => staticcashrate,
      );
      let searchParams = null;
      if (activeKey === 'organization') {
        searchParams = orgSearch;
      }
      if (activeKey === 'country') {
        searchParams = counSearch;
      }
      console.log('searchParams', searchParams);

      const { dimensions, searchData } = handleParams(searchParams);
      const { startDate: sd, endDate: ed, ecticy, punctuation, ecticyVal } = searchParams;
      const startDate = moment(sd).format('YYYY-MM-DD 00:00:00');
      const endDate = moment(ed).format('YYYY-MM-DD 23:59:59');

      crudRequest('/api/route/waybillCashRateNationwide/search');

      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      // 公共查询条件  dimensions为空时，查询全国
      const gcNewParam: IGnerCondit = {
        dataSource,
        dimensions: dimensions ? dimensions : ['ticket'], // 分组
        aggregators: dimensions ? [CountTicket] : [CountAllArea], // 聚合
        startDate,
        endDate,
      };
      const gc = new GenerateCondit<ActualDetail>(gcNewParam);

      let boundList = [];
      /** 兑现共用 规划时效 start */
      if (ecticy && punctuation && ecticyVal) {
        const efficiencyBound = handlerEcticyBound(searchParams);
        boundList = [...boundList, efficiencyBound];
      }
      /** 规划时效 end */

      // 签收  包含 [ 兑现，未兑现，null ]
      // 签收票数 andfilters
      let entity = new ActualDetail({ ...searchData });
      let data = [],
        condit;
      //#region  签收 monthSumTicket
      gc.setBoundFilters(boundList);
      condit = gc.converCondit(entity);
      data = yield getData(condit);
      /** 签收 */
      const signNote_data = new Queryable<ActualDetail>(data);
      //#endregion
      // console.log('signNote_data所有签收: ', signNote_data, dimensions);

      let signNote_data_map = signNote_data.reduce((pre, curr) => {
        let key =
          dimensions?.length == 1
            ? curr[dimensions[0]]
            : dimensions?.length == 2
            ? curr[dimensions[0]] + curr[dimensions[1]]
            : 'init';
        pre[key] = curr;
        return pre;
      }, {});
      // console.log('signNote_data_map:', signNote_data_map);

      /** -------------------------------------------------------------------------------- */

      //#region 此处查询已兑现用于计算
      // 已兑现 票数 andilters
      entity.onTime = '是';
      condit = gc.converCondit(entity);
      data = yield getData(condit);
      const cashOrder_data = new Queryable<ActualDetail>(data);
      // console.log('cashOrder_data已兑现: ', cashOrder_data);
      //#endregion

      let cashOrder_data_map = cashOrder_data.reduce((pre, curr) => {
        let key =
          dimensions?.length == 1
            ? curr[dimensions[0]]
            : dimensions?.length == 2
            ? curr[dimensions[0]] + curr[dimensions[1]]
            : 'init';
        pre[key] = curr;
        return pre;
      }, {});
      // console.log('cashOrder_data_map:', cashOrder_data_map);

      /** -------------------------------------------------------------------------------- */

      // 未兑现 andilters
      entity.onTime = '否';
      condit = gc.converCondit(entity);
      data = yield getData(condit);
      const notCashOrder_data = new Queryable<ActualDetail>(data);
      // console.log('notCashOrder_data未兑现: ', notCashOrder_data);

      let notCashOrder_data_map = notCashOrder_data.reduce((pre, curr) => {
        let key =
          dimensions?.length == 1
            ? curr[dimensions[0]]
            : dimensions?.length == 2
            ? curr[dimensions[0]] + curr[dimensions[1]]
            : 'init';
        pre[key] = curr;
        return pre;
      }, {});
      // console.log('notCashOrder_data_map:', notCashOrder_data_map);

      /** -------------------------------------------------------------------------------- */

      // 用于查找匹配相同营运区的谓词[=出发营运区]
      const byOriginProvArea = (compar: ActualDetail): Result<ActualDetail, boolean> => {
        if (dimensions) {
          if (dimensions.length === 1) {
            return (item) => item[dimensions[0]] === compar[dimensions[0]];
          }
          if (dimensions.length === 2) {
            return (item) =>
              item[dimensions[0]] === compar[dimensions[0]] &&
              item[dimensions[1]] === compar[dimensions[1]];
          }
        } else {
          return () => true;
        }
      };

      const byOriginProvAreaKey = (item: ActualDetail): string => {
        return dimensions?.length == 1
          ? item[dimensions[0]]
          : dimensions?.length == 2
          ? item[dimensions[0]] + item[dimensions[1]]
          : 'init';
      };

      const converRate = (dividens, divisor) => {
        return divisor ? ((dividens / divisor) * 100).toFixed(0) + '%' : '--';
      };

      const dataList = signNote_data.maps((signNote, i) => {
        // 以累积规划签收为基准,各项集合中找到与之相匹配的[出发营运区]
        // let cashOrder = cashOrder_data.finds(byOriginProvArea(signNote))?.ticket || 0; // 兑现
        // let cashNotOrder = notCashOrder_data.finds(byOriginProvArea(signNote))?.ticket || 0; // 未兑现

        let cashOrder = cashOrder_data_map[byOriginProvAreaKey(signNote)]?.ticket || 0; // 兑现
        let cashNotOrder = notCashOrder_data_map[byOriginProvAreaKey(signNote)]?.ticket || 0; // 未兑现

        if (!dimensions) {
          // cashOrder = cashOrder_data.finds(byOriginProvArea(signNote))?.count || 0; // 兑现
          // cashNotOrder = notCashOrder_data.finds(byOriginProvArea(signNote))?.count || 0; // 未兑现
          cashOrder = cashOrder_data_map[byOriginProvAreaKey(signNote)]?.count || 0; // 兑现
          cashNotOrder = notCashOrder_data_map[byOriginProvAreaKey(signNote)]?.count || 0; // 未兑现
        }
        const monthSumHonorRate = converRate(
          cashOrder,
          dimensions ? signNote.ticket : signNote.count,
        ); // 签收率(%)
        return {
          originProvinceArea: !!dimensions
            ? signNote[dimensions[0]]
              ? signNote[dimensions[0]]
              : '--'
            : '--', // 出发组织
          destinationProvinceArea:
            dimensions && dimensions.length === 2
              ? signNote[dimensions[1]]
                ? signNote[dimensions[1]]
                : '--'
              : '--', // 到达组织
          monthSumTicket: cashOrder, // 兑现票数
          cashNotOrder,
          monthSumHonor: dimensions ? signNote.ticket : signNote.count, // 签收票数
          monthSumHonorRate, // 兑现率
        };
      });
      if (activeKey === 'organization') {
        yield put({
          type: 'updateState',
          payload: { organizationTable: dataList, orgPage: 1, orgPageSize: 20 },
        });
      }
      if (activeKey === 'country') {
        yield put({
          type: 'updateState',
          payload: { countryTable: dataList, counPage: 1, counPageSize: 20 },
        });
      }
    },

    // 图表
    *getProduct(_, { put, call, select }) {
      const { orgSearch, counSearch, activeKey } = yield select(
        ({ staticcashrate }) => staticcashrate,
      );
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      let searchParams;
      if (activeKey === 'organization') {
        searchParams = orgSearch;
      }
      if (activeKey === 'country') {
        searchParams = counSearch;
      }
      const { dimensions, searchData } = handleParams(searchParams);
      const { startDate: sd, endDate: ed, ecticy, punctuation, ecticyVal } = searchParams;
      const startDate = moment(sd).format('YYYY-MM-DD 00:00:00');
      const endDate = moment(ed).format('YYYY-MM-DD 23:59:59');
      const dataInCondit: IGnerCondit = {
        dataSource,
        dimensions,
        startDate,
        endDate,
        queryType: 'timeSeries',
        simpleGranularity: 'day',
        aggregators: [new Aggregator('count', 'count', 'waybillNo')],
      };
      //#region 查询条件
      // 签收
      const gcPlan = new GenerateCondit<ActualDetail>(dataInCondit);
      let entity = new ActualDetail({ ...searchData });
      let condit = gcPlan.converCondit(entity);
      const dataAll = yield getTimestampData(condit);
      // console.log('签收dataAll: ', dataAll);
      //#endregion

      //#region 兑现
      // 兑现
      const gc = new GenerateCondit<ActualDetail>({
        ...dataInCondit,
        aggregators: [CountTicket],
      });
      /** 规划时效 start */
      let boundList = [];
      if (ecticy && punctuation && ecticyVal) {
        const efficiencyBound = handlerEcticyBound(searchParams);
        boundList = [...boundList, efficiencyBound];
      }
      gc.setBoundFilters(boundList);
      /** 规划时效 end */
      entity.onTime = '是';
      condit = gc.converCondit(entity);
      const dataOnTime = yield getTimestampData(condit); // 兑现票数
      // console.log('兑现dataOnTime: ', dataOnTime);
      //#endregion

      // 获取时间范围
      const timestamps = dealDate(
        moment(startDate).format('YYYY-MM-DD'),
        moment(endDate).format('YYYY-MM-DD'),
      );
      // 计算单日兑现率
      const RedemptionRate = timestamps.map((i) => {
        const actualItem = dataOnTime.find(
          (item) => moment(i).format('YYYY-MM-DD') === moment(item?.timestamp).format('YYYY-MM-DD'),
        );
        const allItem = dataAll.find(
          (item) => moment(i).format('YYYY-MM-DD') === moment(item?.timestamp).format('YYYY-MM-DD'),
        );
        if (!actualItem?.ticket) return 0; // 兑现票数
        if (!allItem?.count) return 0;
        const ratio = allItem.count !== 0 ? actualItem.ticket / allItem.count : 0;
        return ratio ? Number.parseInt(((ratio || 0) * 100).toFixed(0)) : 0;
      });
      const productDataList = [{ name: `${'全产品'}(%)`, value: RedemptionRate }];

      if (activeKey === 'organization') {
        yield put({
          type: 'updateState',
          payload: {
            organizationProductDataList: productDataList,
            organizationTimestamps: timestamps,
          },
        });
      }
      if (activeKey === 'country') {
        yield put({
          type: 'updateState',
          payload: { countryProductDataList: productDataList, countryTimestamps: timestamps },
        });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    // updateSearchParams(state, { payload }) {
    //   return { ...state, searchParams: { ...state.searchParams, ...payload } };
    // },
    updateCounty(state, { payload }) {
      return { ...state, counSearch: { ...state.counSearch, ...payload } };
    },
    updateOrganization(state, { payload }) {
      return { ...state, orgSearch: { ...state.orgSearch, ...payload } };
    },
  },
};

const productTypeList = [
  { key: 'productType', value: '定时达', label: '定时达' },
  { key: 'superiorityProduct', value: '是', label: '优势业务' },
  // { key: 'lengthOfTime', value: '次日达', label: '次日达' },
  // { key: 'lengthOfTime', value: '隔日达', label: '隔日达' },
];

const handleParams = (searchParams) => {
  const { productType, direction, departureCenter, arrivalCenter } = searchParams;
  let dimensions = null; // 聚合
  let searchData = {};
  // 处理出发到达组织 andfilters
  if (direction) {
    dimensions = direction.split(',');
    if (dimensions.length === 1) {
      if (isArray(departureCenter)) {
        searchData[dimensions[0]] = departureCenter?.map((item) => item.value);
      } else {
        searchData[dimensions[0]] = departureCenter?.code;
      }
    }
    if (dimensions.length === 2) {
      if (isArray(departureCenter)) {
        searchData[dimensions[0]] = departureCenter?.map((item) => item.value);
      } else {
        searchData[dimensions[0]] = departureCenter?.code;
      }

      if (isArray(arrivalCenter)) {
        searchData[dimensions[1]] = arrivalCenter?.map((item) => item.value);
      } else {
        searchData[dimensions[1]] = arrivalCenter?.code;
      }
    }
  }
  // 处理产品类型productLinType  andfilters
  if (productType && productType.length > 0) {
    productType.forEach((item) => {
      const { value } = item;
      const obj = productTypeList.find((i) => i.value === value);
      if (obj?.key) {
        searchData = { ...searchData, [obj?.key]: obj?.value };
      }
    });
  }
  return { dimensions: dimensions?.map((item) => item.replace('Code', '')), searchData };
};

const handlerEcticyBound = (searchParams) => {
  const { ecticy, punctuation, ecticyVal } = searchParams;

  let efficiencyBound;
  let range: { left?: string; right?: string } = {};
  switch (punctuation) {
    case 'd':
      range.left = ecticyVal + 1 + '';
      break;
    case 'dd':
      range.left = ecticyVal + '';
      break;
    case 'ddd':
      range.left = ecticyVal + '';
      range.right = ecticyVal + '';
      break;
    case 'x':
      range.right = ecticyVal - 1 + '';
      break;
    case 'xd':
      range.right = ecticyVal + '';
      break;
  }
  efficiencyBound = new Bound(ecticy, range?.left, range?.right);
  const { lowerValue, upperValue, dimension } = efficiencyBound;
  // 去除多余参数
  let truthEffice;
  if (typeof lowerValue === 'string') {
    truthEffice = {
      dimension,
      lowerValue,
      lowerEq: efficiencyBound.lowerEq,
    };
  }
  if (typeof upperValue === 'string') {
    truthEffice = {
      ...truthEffice,
      dimension,
      upperValue,
      upperEq: efficiencyBound.upperEq,
    };
  }
  return truthEffice;
};
